import React from 'react'

import { TSignal } from 'interface'

const Signal = ({ type }: TSignal) => {
  switch (type) {
    case 'error': {
      return (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
            fill="#F56A50"
          />
          <circle
            cx="32.0003"
            cy="32"
            r="13.3333"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 28L36 36"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 36L36 28"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    }
    case 'success': {
      return (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
            fill="#00AA4F"
          />
          <circle
            cx="32.0003"
            cy="32"
            r="13.3333"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.8702 32.0117C28.3746 31.5311 27.5832 31.5433 27.1026 32.0389C26.622 32.5345 26.6342 33.3259 27.1298 33.8065L28.8702 32.0117ZM30.5 35.3333L29.6298 36.2307C30.1147 36.7009 30.8853 36.7009 31.3702 36.2307L30.5 35.3333ZM36.8702 30.8974C37.3658 30.4168 37.378 29.6254 36.8974 29.1298C36.4168 28.6342 35.6254 28.622 35.1298 29.1026L36.8702 30.8974ZM27.1298 33.8065L29.6298 36.2307L31.3702 34.436L28.8702 32.0117L27.1298 33.8065ZM31.3702 36.2307L36.8702 30.8974L35.1298 29.1026L29.6298 34.436L31.3702 36.2307Z"
            fill="white"
          />
        </svg>
      )
    }
    case 'warning': {
      return (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z"
            fill="#FFC700"
          />
          <circle
            cx="32.0003"
            cy="32"
            r="13.3333"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32 25.3334V33.3334L36 36"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    }
    case 'alert':
      return (
        <svg
          width="64"
          height="65"
          viewBox="0 0 64 65"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.5" width="64" height="64" rx="32" fill="#FFC700" />
          <path
            d="M32 25.1667C32.7364 25.1667 33.3334 25.7637 33.3334 26.5V34.5C33.3334 35.2364 32.7364 35.8334 32 35.8334C31.2637 35.8334 30.6667 35.2364 30.6667 34.5V26.5C30.6667 25.7637 31.2637 25.1667 32 25.1667Z"
            fill="white"
          />
          <path
            d="M32 39.8334C32.7364 39.8334 33.3334 39.2364 33.3334 38.5C33.3334 37.7637 32.7364 37.1667 32 37.1667C31.2637 37.1667 30.6667 37.7637 30.6667 38.5C30.6667 39.2364 31.2637 39.8334 32 39.8334Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3334 32.5C17.3334 24.3999 23.8999 17.8334 32 17.8334C40.1002 17.8334 46.6667 24.3999 46.6667 32.5C46.6667 40.6002 40.1002 47.1667 32 47.1667C23.8999 47.1667 17.3334 40.6002 17.3334 32.5ZM32 20.5C25.3726 20.5 20 25.8726 20 32.5C20 39.1275 25.3726 44.5 32 44.5C38.6275 44.5 44 39.1275 44 32.5C44 25.8726 38.6275 20.5 32 20.5Z"
            fill="white"
          />
        </svg>
      )
    default:
      return null
  }
}

export default Signal
